export function hasFeature(user: User | null, featureName: FeatureName) {
  return user?.hasActiveSubscription && user?.firm?.subscription?.features.some(feature => feature.name === featureName);
}

export function getFeatureLimit(user: User, featureName: FeatureName): number {
  if (!user.firm) {
    return 0;
  }
  const feature = user.firm.subscription.features.find(feature => feature?.name === featureName);
  return feature?.value || 0;
}

export function isBillingAdmin(user: User): boolean {
  if (!user.firm) {
    return false;
  }
  return user.firm.billingUser.id === user.id;
}

export type UsageLevel = 'ok' | 'warning' | 'over';

/** How close the firm is to its Xero connection limit. Warning from 90% so there is time to upgrade. */
export function getConnectionUsage(connectionCount: number, connectionLimit: number): { percent: number; level: UsageLevel } {
  const percent = Math.min(100, Math.round((connectionCount / connectionLimit) * 100));
  if (connectionCount > connectionLimit) {
    return { percent, level: 'over' };
  }
  return { percent, level: connectionCount / connectionLimit >= 0.9 ? 'warning' : 'ok' };
}

/** The backend uses Integer.MAX_VALUE-style limits for unlimited features. */
export function isUnlimited(limit: number) {
  return limit >= 1_000_000;
}
